<template>
  <div id="unitDetails">

    <div class="section-content" ref="scrollArea">

      <template v-if="selected">
    
        <!-- UNIT DETAILS -->
        <div class="vo-card">
        
          <div class="vo-header">
            Unit Details
          </div>
          <div class="vo-content">
            <div class="details">

              <div class="vo-s-list">
                <div class="name">Unit #</div>
                <div class="value">{{ unit.title }}</div>
              </div>
              
              <div class="vo-s-list">
                <div class="name">Property</div>
                <div class="value" :class="{selectable: this.hasPermissions(['property'])}" @click="openProperty(unit.property)">{{ property.name }}</div>
              </div>

              <div class="vo-s-list">
                <div class="name">Unit Type</div>
                <div class="value">{{ unitType.name }}</div>
              </div>

              <div class="vo-s-list">
                <div class="name">Address</div>
                <div class="value">
                  <div v-if="unit.address">
                    <div><span v-if="unit.address.line2">{{ unit.address.line2 }} - </span>{{ unit.address.line1 }}</div>
                    <div>{{ unit.address.city }}, {{ unit.address.province }} {{ unit.address.country }}</div>
                    <div>{{ unit.address.postal }}</div>
                  </div>
                  <div v-else-if="property.address">
                    <div><span v-if="property.address.line2">{{ property.address.line2 }} - </span>{{ property.address.line1 }}</div>
                    <div>{{ property.address.city }}, {{ property.address.province }} {{ property.address.country }}</div>
                    <div>{{ property.address.postal }}</div>
                  </div>
                </div>
              </div>

            </div>
            <div class="clear"></div>
          </div>
          <div class="vo-footer">
            <v-btn class="vo-button" flat @click="routeAddQueries({ dialog: 'unit-manage', dialogAction: 'edit' })">
              <v-icon>mdi-pencil</v-icon>
              <span>Edit</span>
            </v-btn>
            <v-btn flat class="vo-button red" @click="deleteUnitDialog">
              <v-icon>mdi-delete</v-icon>
              <span>Delete</span>
            </v-btn>
          </div>
        </div>

        <!-- UNIT ROLES -->
        <div class="vo-card" v-if="hasPermissions(['user'], this.unit.property)">
          <div class="vo-header">
            Unit Roles
            <div class="vo-actions">
              <v-btn flat fab small class="vo-icon-button" @click="openInvite">
                <v-icon medium>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <div>
            <vo-list class="list" v-if="app.pages.units.unitRoles.list" :list="app.pages.units.unitRoles.list">
              <div class="user-role" slot="itemSlot" slot-scope="item" v-ripple @click="openUser(item.item)">
                <vo-avatar class="avatar" :size="32" :user="$store.getters.user(item.item)"></vo-avatar>
                <div class="text">
                  <div class="name">{{ $store.getters.user(item.item).fullName }}</div>
                  <div class="email">{{ $store.getters.user(item.item).email }}</div>
                </div>
                <div class="icon">
                  <i class="mdi mdi-24px mdi-chevron-right"></i>
                </div>
              </div>
            </vo-list>
      
          </div>
        </div>

        <!-- UNIT TICKETS -->
        <div class="vo-card" v-if="hasPermissions(['ticket', 'ticketAdmin', 'ticketManager'], this.unit.property)">
          <div class="vo-header">
            Unit Tickets
            <div class="vo-actions">
              <v-btn flat fab small class="vo-icon-button" @click="openTicketCreate">
                <v-icon medium>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <div>
            <vo-list class="list" v-if="app.pages.units.unitTickets.list" :list="app.pages.units.unitTickets.list" itemComponent="vo-ticket-list" selectable @itemSelected="openTicket"></vo-list>
          </div>
        </div>
        

      </template>

      <template v-else>
        <vo-empty-state text="SELECT A UNIT"></vo-empty-state>
      </template>
    </div>

    <vo-details-header></vo-details-header>
  
  </div>
</template>

<script>

  import DetailsMixin     from '../mixins/detailsMixin.js';
  import permissionMixin  from '../mixins/permissionMixin.js';

  export default {
    
    mixins: [DetailsMixin, permissionMixin],
    
    data () {
      return {
        
        roles: [
          {
            title: 'Manager',
            accessLevel: 'All Properties'
          },
          {
            title: 'Manager',
            accessLevel: 'All Properties'
          },
          {
            title: 'Manager',
            accessLevel: 'All Properties'
          }
        ],

        timeouts: {
          users: false,
          tickets: false
        }
      }
    },

    methods: {
      
      deleteUnitDialog () {
        
        Dialog.showDialog({
          title: 'Delete Unit',
          body: 'Are you sure you want to delete this unit?',
          confirm: {
            title: 'Delete',
            action: () => {
              return this.$store.dispatch('deleteUnit', { 
                unit: this.unit._id, 
                property: this.unit.property 
              })
              .then(data => {
                
                this.page.list.removeItem(this.page.selected);
                this.page.selected = false;

                this.routeRemoveQuery('details');

                Toast.show('Unit deleted.', 'success');
                return Promise.resolve();
              })
              .catch(e => {
                console.log(e);
                Toast.showError(e);
                return Promise.reject();
              });
            }
          }
        });
      },
      
      loadUnit () {
        this.selectFromDetails(this.page, 'loadUnit', {
          unit: this.$route.query.details
        });
      },

      openInvite () {
        this.routeAddQueries({dialog: 'invite-create', dialogAction: 'selected-unit'});
      },

      openTicketCreate () {
        this.routeAddQueries({dialog: 'ticket-create', dialogItem: (this.property._id + ',' + this.unit._id)});
      },

      openTicket (ticket) {
        
        this.$router.push({
          name: 'tickets',
          query: {
            details: ticket
          }
        });
      },

      openUser (user) {
        
        this.$router.push({
          name: 'joined',
          query: {
            details: user
          }
        });
      },

      openProperty (property) {
        if (!this.hasPermissions(['property'])) return;

        this.$router.push({
          name: 'properties',
          query: {
            details: property
          }
        });
      },

      loadRoles () {
    
        this.timeouts.users = setTimeout(() => {

          // Create Unit Roles list
          if (this.hasPermissionsInProperty(['user'], this.unit.property)) {        
            Vue.set(this.page.unitRoles, 'list', new ListModel({
              ...this.page.unitRoles.listParams,
              params: {
                unit: this.unit._id
              }
            }));        
          }

        }, window.cordova ? 600 : 1); 
      },

      loadTickets () {
        this.timeouts.tickets = setTimeout(() => {

          // Create Unit Ticket list
          if (this.hasPermissionsInProperty(['ticket', 'ticketManager', 'ticketAdmin'], this.unit.property)) {
            Vue.set(this.page.unitTickets, 'list', new ListModel({
              ...this.page.unitTickets.listParams,
              filter: {
                unit: this.unit._id
              },
              params: {
                company: this.unit.company
              }
            }));
          }
        }, window.cordova ? 700 : 1); 
      }

    },

    computed: {

      unit () {
        return this.$store.getters.unit(this.page.selected);
      },

      selected () {
        return this.page.selected;
      },

      property () {
        return this.$store.getters.property(this.unit.property);
      },

      unitType () {
        return this.$store.getters.unitType(this.unit.type);
      }

    },
    
    watch: {

      'selected' () {

        // Check Unit is Set
        if (!this.selected) return;

        // Scroll to top
        this.$refs.scrollArea.scrollTop = 0;

        // Reset Lists
        if (this.page.unitRoles.list)   this.page.unitRoles.list.clearList();
        if (this.page.unitTickets.list) this.page.unitTickets.list.clearList();

        if (this.timeouts.users)   clearTimeout(this.timeouts.users);
        if (this.timeouts.tickets) clearTimeout(this.timeouts.tickets);

        this.loadRoles();
        this.loadTickets();
      },

      '$route.query.details' () {
        this.loadUnit();
      }

    },

    created () {
      this.loadUnit();

      // Unit Updated - Here we handle assignee changes
      document.addEventListener('unitUpdated', (e) => {
        var update = e.detail;

        // Ignore if not selected
        if (this.unit._id !== update._id) return;

        // So far this only happens when Roles are updated
        this.loadRoles();
    
      });
    }
  
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #unitDetails {
    
    @include fontPrimary400();

    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
      
    .section-content {
      @include scrollContainer();
      top: 48px;

      background: $lightGreen; 
      padding: 16px;
      box-sizing: border-box;
    }
  
    .vo-card {

      .avatar {
        margin: 0 20px 0 0;
        float: left;
      }

      .details {
        float: left;
      }

      .selectable {
        color: $primary;
        cursor: pointer;
      }

      .user-role {
        
        @include fontPrimary400();

        position: relative;
        height: 70px;
        padding: 16px;
        cursor: pointer;

        .avatar {
          position: absolute;     
        }

        .text {
          position: absolute;
          top: 12px;
          left: 62px;

          .title {
            color: $black87;
          }

          .email {
            margin: 2px 0 0;
            color: $black54;
          }
        }

        .icon {
          position: absolute;
          top: 20px;
          right: 8px;
        
          i {
            transition: $transitionHover;
          }

        }

        &:not(last-of-type) {
          border-bottom: $borderBlack12;
        }

        &:hover {

          .icon i {
            color: $black87;
          }

        }

      } // .user-role
      
      .empty {
        padding: 24px 0;
      }

    } // .vo-card
  }

</style>



// WEBPACK FOOTER //
// src/components/UnitDetails.vue